<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    width="880px"
    :centered="true"
    :mask-closable="false"
    :footer="null"
    :confirm-loading="confirmLoading"
    @cancel="cancelHanler"
  >
    <div class="expen-service-box">
      <template v-if="page===1">
        <card
          :up="true"
          @upService="upService"
        />
      </template>
      <template v-else-if="page===2">
        <up-service-form
          ref="serviceForm"
          :page="page"
          @formHandler="formHandler"
        />
      </template>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import UpServiceForm from './UpServiceForm'
import Card from './Card'
export default {
  components: {
    Card,
    UpServiceForm
  },
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      page: 1
    }
  },
  computed: {
    ...mapState('service', ['serviceInfo']),
    projectid () {
      return this.projectItemData.projectid
    },
    modalTit () {
      return this.$t('message["1051"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('service', ['getServiceInfo']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    // formHandle () {
    //   this.form.validateFieldsAndScroll(async (err, values) => {
    //     if (!err) {
    //       const formDatas = Object.assign(values, { cid: this.cId })
    //       const chain = await this.ajaxCreateProject(formDatas)
    //       chain.params(formDatas)
    //         .setForm(this.form)
    //         .fetch()
    //       this.form.resetFields()
    //       this.isLimitDialogShow = false
    //     }
    //   })
    // },
    async upService () {
      const chain = await this.getServiceInfo()
      chain.params({ projectid: this.projectItemData.projectid })
        .onSuccess(raw => {
          this.page = 2
          setTimeout(() => {
            this.$refs.serviceForm.initPayData(Number(raw.user_num))
          }, 100)
        })
        .fetch()
    },
    closeHandler () {
      this.isLimitDialogShow = false
      this.page = 1
    },
    cancelHanler () {
      this.isLimitDialogShow = false
      // this.page = 1
    },
    formHandler () {
      this.isLimitDialogShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.open-suc-tip {
  text-align: center;
  margin: 80px auto;
  i {
    color: #42C27E;
    font-size: 80px;
  }
  p {
    line-height: 36px;
    font-size: 18px;
    margin-top: 24px;
  }
}
</style>
